/**
 * Display geometry of the blog article's image slots, shared by every block
 * that renders into one. Feeds the `sizes` attribute (how wide the slot is at
 * a given viewport) and the `srcset` width ladder (which candidates are worth
 * asking Hygraph for) — see utils/hygraphImage.js.
 *
 * `--pad-x` is a constant 24px inside .blog-article, so each tier's content
 * width is `min(100vw, max-width) - 48px`:
 *
 *   .w-wide   max-width 960  ->  up to 912 CSS px   (hero, WIDE images, video)
 *   .w-read   max-width 720  ->  up to 672 CSS px   (READING images)
 *   pair      two .w-wide columns with a 14px gap  ->  up to 449 CSS px,
 *             collapsing to one full-width column at ≤640px
 *
 * Ladders run from a small-phone 1x up to roughly 2x of the widest slot; the
 * srcset builder drops whatever a given asset is too small (or already too
 * well compressed) to benefit from.
 */

export const WIDE_SIZES = "(max-width: 960px) calc(100vw - 48px), 912px";
export const WIDE_WIDTHS = [400, 560, 720, 912, 1200, 1460, 1824];

export const READ_SIZES = "(max-width: 720px) calc(100vw - 48px), 672px";
export const READ_WIDTHS = [360, 480, 672, 900, 1120, 1344];

export const PAIR_SIZES = [
  "(max-width: 640px) calc(100vw - 48px)",
  "(max-width: 960px) calc((100vw - 62px) / 2)",
  "449px",
].join(", ");
export const PAIR_WIDTHS = [320, 449, 600, 760, 898, 1200];
